import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBreadcrumbsDivider } from 'vuetify/lib/components/VBreadcrumbs';
import { VBreadcrumbsItem } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "index container" },
    [
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [_c("router-view", { on: { showParent: _vm.showParent } })],
        1
      ),
      _vm.showParentPage
        ? _c(
            "div",
            [
              _c(
                VBreadcrumbs,
                [
                  _c(
                    VBreadcrumbsItem,
                    {
                      attrs: { exact: true, to: { name: "home", params: {} } },
                    },
                    [_vm._v("Home")]
                  ),
                  _c(VBreadcrumbsDivider, [_vm._v("/")]),
                  _c(
                    VBreadcrumbsItem,
                    {
                      attrs: {
                        exact: true,
                        to: { name: "productSpecsElement", params: {} },
                        active: "",
                      },
                    },
                    [_vm._v(" Product Specs Element ")]
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "d-flex flex-column flex-lg-row" },
                [
                  _c(VTextField, {
                    attrs: {
                      dense: "",
                      placeholder: "Press enter to begin search",
                      "append-icon": "mdi-magnify",
                      outlined: "",
                      clearable: "",
                      label: "Search",
                    },
                    on: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.search.apply(null, arguments)
                      },
                      "click:clear": _vm.search,
                      "click:append": _vm.search,
                    },
                    model: {
                      value: _vm.searchTerms,
                      callback: function ($$v) {
                        _vm.searchTerms = $$v
                      },
                      expression: "searchTerms",
                    },
                  }),
                  _c(
                    VBtn,
                    {
                      staticClass:
                        "ml-0 ml-lg-4 mb-2 mb-lg-0 align-self-end align-self-lg-start",
                      attrs: {
                        color: "primary",
                        to: { name: "productSpecsElementCreate", params: {} },
                      },
                    },
                    [_vm._v(" Create Product Specs Element ")]
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "table-container" },
                [
                  _c(VDataTable, {
                    staticClass: "elevation-1",
                    attrs: {
                      headers: _vm.headers,
                      items: _vm.productSpecsElementList,
                      "items-per-page": _vm.pagination.pageSize,
                      loading: !_vm.productSpecsElementProcessed,
                      "server-items-length": _vm.pagination.totalSize,
                      page: _vm.pagination.current,
                      "disable-sort": true,
                      "item-key": "id",
                    },
                    on: { "update:options": _vm.pageChanged },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "item.actions",
                          fn: function ({ item }) {
                            return [
                              _c(
                                VIcon,
                                {
                                  staticClass: "mr-2",
                                  attrs: { small: "" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.edit(item)
                                    },
                                  },
                                },
                                [_vm._v(" mdi-pencil ")]
                              ),
                              _c(
                                VIcon,
                                {
                                  staticClass: "mr-2",
                                  attrs: { small: "" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.remove(item)
                                    },
                                  },
                                },
                                [_vm._v(" mdi-delete ")]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3244886510
                    ),
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c("confirmation-dialog", { ref: "confirm" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }